import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import LogoDark from '../../Images/LiquidQR-dark.png';
import QrImage from '../../Images/qr-background3.png'
import { AnimatePresence, motion } from 'motion/react';
import { transition, variants } from './variants';
import { useAuth } from '../../../utils/Auth';
import { useNavigation } from '../../../utils/NavigationContext';
import styles from './Menu.module.css';

export default function Menu(props) {

    const { ref, showMenu, setShowMenu, handleLogout } = props;
    const { pinned, setPinned } = useNavigation();

    const { currentUser, orgObj } = useAuth();
    const plan = useMemo(() => orgObj?.plan, [orgObj?.plan]);

    const navigate = useNavigate();

    const handleNavigate = (location) => {
        setShowMenu(false);
        switch(location) {
            case 'home':
                return navigate('/');
            case 'collection':
            case 'analytics':
            case 'settings':
			case 'widgets':
			case 'organizations':
                return navigate(`/${location}`);
            case 'login':
            case 'signup':
                return navigate(`/auth?mode=${location}`);
            default:
                break;
        }
    };

    const handleReturn = useMemo(() => {
        if (currentUser) {
            return (
                <>
                <button type='button' className={`${styles.pinBtn} ${pinned ? styles.pinned : null}`} onClick={() => setPinned(!pinned)}>
                    <i className="far fa-thumbtack" />
                </button>
                <div className={styles.header}>
                    <img src={LogoDark} alt='liquid logo' width='100%' />
                    <h4>LiquidQR</h4>
                </div>
                <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('home')}><i className='fas fa-home' />Home</button>
                <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('collection')}>QR Codes</button>
				        <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('organizations')}>Organization</button>
                <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('widgets')}>Widgets</button>
                {(plan?.analytics > 1 || plan?.plan_id > 2) &&
                    <button className={styles.menuBtn} onClick={() => handleNavigate('analytics')} >Analytics</button>
                }
                <div className={styles.linkWrap}>
                    <button type='button' className={styles.link} onClick={() => handleNavigate('settings')}><i className='fas fa-gear me-1' style={{pointerEvents: 'none'}} />Settings</button>
                    |
                    <button type='button' className={styles.link} onClick={(e) => handleLogout(e)} >Logout</button>
                </div>
                </>
            );
        } else {
            return (
                <>
                <div className={styles.header}>
                    <img src={LogoDark} alt='liquid logo' width='100%' />
                    <h4>LiquidQR</h4>
                </div>
                <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('login')}>Log In</button>
                <button type='button' className={styles.menuBtn} onClick={() => handleNavigate('signup')}>Sign Up</button>
                </>
            )
        };
    },[currentUser, pinned, plan]);

    return (
        <AnimatePresence initial={false}>
            {(showMenu || pinned) && (
                <motion.div 
                    key='menu'
                    className={styles.container}
                    transition={transition}
                    variants={variants}
                    initial='hideMenu'
                    animate='showMenu'
                    exit='hideMenu'
                    ref={ref}
                    style={{backgroundImage: `url(${QrImage})`}}
                >
                    {handleReturn}
                </motion.div>
            )}
        </AnimatePresence>
    );
};